module.exports = __webpack_public_path__ + "h5/img/master_7.c1d0f52c.jpg";